// 🪝🪝🪝🪝🪝
import { useQuery } from '@tanstack/react-query';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import {
  getTemporalListingPriceForecast,
  getTemporalOccupancyRatings,
} from './apiHelpers';

export const useTemporalOccupancyRatings = () => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: ['restaurant', restaurantId, 'temporalOccupancyRatings'],
    queryFn: async () => getTemporalOccupancyRatings(restaurantId),
    initialData: {
      timeOfDayOccupancyRatings: [],
      dayOfWeekOccupancyRatings: [],
      monthOfYearOccupancyRatings: [],
    },
  });
};

export const useTemporalListingPriceForecast = (
  startDate: string,
  endDate: string,
) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: [
      'restaurant',
      restaurantId,
      'temporalListingPriceForecast',
      startDate,
      endDate,
    ],
    queryFn: () =>
      getTemporalListingPriceForecast(restaurantId, startDate, endDate),
  });
};
